module.exports = __webpack_public_path__ + "media/31.858527b5.mp3";